import { apiFetch } from "./api-client";
export type PurchaseOrderType = { id: string; name: string; active: number; usageCount: number };
export type PurchaseOrderSettings = { orderTypes: string[]; types: PurchaseOrderType[]; shopAddress: string };
export async function loadPurchaseOrderSettings(signal?: AbortSignal): Promise<PurchaseOrderSettings | null> {
  const response = await apiFetch("/api/v1/workspace/inventory/settings", { signal });
  if (response.status === 404) return null;
  const payload = await response.json();
  if (!response.ok) throw new Error(payload.error?.message || "Unable to load purchase order settings.");
  return payload.data;
}
